(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mount = root => root.querySelectorAll('[data-mce-gallery-carousel]').forEach(el => {
    if (el.dataset.galleryReady) return;
    const track = el.querySelector('.mce-slide-track');
    const slides = [...track.querySelectorAll('.mce-usecase')];
    const dots = [...el.querySelectorAll('[data-mce-gallery-dot]')];
    const status = el.querySelector('[data-mce-gallery-status]');
    if (!slides.length) return;
    el.dataset.galleryReady = 'true';
    let index = Math.min(slides.length - 1, Number(el.dataset.mceInitialSlide) || 0);
    let raf = 0, pending = null;
    const abort = new AbortController();
    const offset = i => Math.min(slides[i].offsetLeft - slides[0].offsetLeft, track.scrollWidth - track.clientWidth);
    const update = () => {
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      status.textContent = `${index + 1} / ${slides.length}`;
      el.dataset.galleryIndex = String(index);
    };
    const go = (target, animate = true) => {
      index = Math.max(0, Math.min(slides.length - 1, target));
      pending = index;
      update();
      track.scrollTo({left: offset(index), behavior: animate && !reduced.matches ? 'smooth' : 'instant'});
      if (Math.abs(track.scrollLeft - offset(index)) < 1) pending = null;
    };
    const cancelPending = () => { pending = null; };
    const sync = () => {
      raf = 0;
      if (pending !== null && Math.abs(track.scrollLeft - offset(pending)) >= 1) return;
      pending = null;
      index = slides.reduce((best, slide, i) => Math.abs(offset(i) - track.scrollLeft) < Math.abs(offset(best) - track.scrollLeft) ? i : best, 0);
      update();
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), {signal: abort.signal}));
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, {passive: true, signal: abort.signal});
    track.addEventListener('scrollend', () => { pending = null; sync(); }, {signal: abort.signal});
    ['pointerdown', 'touchstart', 'wheel'].forEach(type => track.addEventListener(type, cancelPending, {passive: true, signal: abort.signal}));
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      const target = {ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: slides.length - 1}[event.key];
      if (target !== undefined) { event.preventDefault(); go(target); }
    }, {signal: abort.signal});
    const resize = new ResizeObserver(() => go(index, false));
    resize.observe(track);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(el)) return;
      cancelAnimationFrame(raf); resize.disconnect(); abort.abort();
    }, {signal: abort.signal});
    go(index, false);
  });
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
